import React, { useEffect, createElement } from 'react';
const SITE_TITLE = 'Richard M Oblath | Non-Executive Director & Board Chair';
const SITE_DESCRIPTION = 'Richard M Oblath (BSc Hons, PhD, CEng, FIMMM) — Non-Executive Director and Chair with 40 years of global industrial leadership across strategy, M&A, risk, the energy transition, and corporate governance. Available for NED and Chair appointments.';
const SITE_KEYWORDS = 'Richard M Oblath, Non-Executive Director, NED, Board Chair, Board Director, Corporate Governance, Energy Transition, M&A, Strategy, FIMMM, CEng, Shell, Executive Leadership, Board Appointments';
const SITE_URL = 'https://richardoblath.com';
const OG_IMAGE = 'https://cdn.magicpatterns.com/uploads/4vtPTTcnQeusRQ3ASNQ9xd/2098567a-631a-4856-bd70-d92c22037899.jpg';
function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}
export function Seo() {
  useEffect(() => {
    document.title = SITE_TITLE;
    document.documentElement.lang = 'en';
    upsertMeta('name', 'description', SITE_DESCRIPTION);
    upsertMeta('name', 'keywords', SITE_KEYWORDS);
    upsertMeta('name', 'author', 'Richard M Oblath');
    upsertMeta('name', 'robots', 'index, follow');
    upsertMeta('name', 'viewport', 'width=device-width, initial-scale=1, viewport-fit=cover');
    // Open Graph
    upsertMeta('property', 'og:type', 'profile');
    upsertMeta('property', 'og:title', SITE_TITLE);
    upsertMeta('property', 'og:description', SITE_DESCRIPTION);
    upsertMeta('property', 'og:url', SITE_URL);
    upsertMeta('property', 'og:image', OG_IMAGE);
    upsertMeta('property', 'og:site_name', 'Richard M Oblath');
    upsertMeta('property', 'profile:first_name', 'Richard');
    upsertMeta('property', 'profile:last_name', 'Oblath');
    // Twitter
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', SITE_TITLE);
    upsertMeta('name', 'twitter:description', SITE_DESCRIPTION);
    upsertMeta('name', 'twitter:image', OG_IMAGE);
    upsertLink('canonical', SITE_URL);
    // Structured data — schema.org Person (rich results for executive search)
    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'Person',
      name: 'Richard M Oblath',
      honorificSuffix: 'BSc (Hons), PhD, CEng, FIMMM',
      jobTitle: 'Non-Executive Director',
      image: OG_IMAGE,
      email: 'mailto:rmoblath@gmail.com',
      telephone: '+44-7380-968855',
      url: SITE_URL,
      description: SITE_DESCRIPTION,
      sameAs: ['https://www.linkedin.com/in/richard-m-oblath-phd-ceng-fimmm-090ab924/'],
      address: {
        '@type': 'PostalAddress',
        addressRegion: 'Cornwall',
        addressCountry: 'GB'
      },
      knowsAbout: ['Corporate Governance', 'Energy Transition', 'Mergers and Acquisitions', 'Strategy', 'Risk Management', 'Transformational Change'],
      subjectOf: {
        '@type': 'PodcastEpisode',
        name: 'Will the $65bln Unilever-McCormick Food deal create value?',
        partOfSeries: {
          '@type': 'PodcastSeries',
          name: 'The Mergers & Acquisitions Podcast'
        },
        datePublished: '2026-06-28',
        url: 'https://podcasts.apple.com/gb/podcast/will-the-%2465bln-unilever-mccormick-food-deal-create-value/id1665680837?i=1000774175673'
      },
      alumniOf: [{
        '@type': 'CollegeOrUniversity',
        name: 'Imperial College London'
      }, {
        '@type': 'CollegeOrUniversity',
        name: 'University of Nottingham'
      }]
    };
    const scriptId = 'person-json-ld';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(jsonLd);
  }, []);
  return null;
}